var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccupationalhealth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-1567 -285)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(1567 285)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ccf760fea9058271202791647ba3ac31",
    transform: "translate(1538.043 253.56)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 25.706,
    cy: 25.706,
    r: 25.706,
    transform: "translate(36.252 36.252)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 22.116,
    cy: 22.116,
    r: 22.116,
    transform: "translate(39.843 39.843)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(53.371 77.264)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 8.588,
    cy: 8.588,
    r: 8.588,
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M113.2,209.37a1.5,1.5,0,0,1-1.064-.441l-2.964-2.964a1.505,1.505,0,0,1,2.129-2.129l1.9,1.9,3.77-3.77A1.505,1.505,0,0,1,119.1,204.1l-4.834,4.834A1.5,1.5,0,0,1,113.2,209.37Z",
    transform: "translate(-105.541 -196.231)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(45.634 47.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M105.4,100.984H76.6v-.995A14.4,14.4,0,0,1,91,85.587h0a14.4,14.4,0,0,1,14.4,14.4v.995Z",
    transform: "translate(-74.675 -83.319)",
    fill: "#eee",
    stroke: "#494f54",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M101.171,144.948H70.95a1.214,1.214,0,0,1-1.214-1.214v-1.981a1.214,1.214,0,0,1,1.214-1.214h30.221a1.214,1.214,0,0,1,1.214,1.214v1.981A1.214,1.214,0,0,1,101.171,144.948Z",
    transform: "translate(-69.736 -122.874)",
    fill: "#eee",
    stroke: "#494f54",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M94.777,89.51V78.489a1,1,0,0,1,1-1h5.454a1,1,0,0,1,1,1V89.51a1,1,0,0,1-1,1H95.774A1,1,0,0,1,94.777,89.51Zm-7.759,5.647v-3.6A.551.551,0,0,1,87.569,91h3.306a.551.551,0,0,1,.551.551v3.6Zm18.646,0v-3.6a.551.551,0,0,1,.551-.551h3.306a.551.551,0,0,1,.551.551v3.6Z",
    transform: "translate(-82.176 -77.493)",
    fill: "#eee",
    stroke: "#494f54",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupationalhealth);
export default __webpack_public_path__ + "static/media/occupationalhealth.de97c6783a97f328703e89d3f261f1e7.svg";
export { ForwardRef as ReactComponent };